(function () {
  'use strict';

  angular
    .module('fdpExceedanceReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('fdpExceedanceReport', {
        url: '/fdp-exceedance-report',
        views: {
          'fdpExceedanceReportView': {
            templateUrl: 'fdp-exceedance-report/views/fdp-exceedance-report.tpl.html',
            controller: 'FdpExceedanceReportCtrl',
            controllerAs: 'fdpExceedanceReport'
          }
        }
      });
  }
}());
